import { useEffect } from "react";

const SITE = "https://iridescent-spa.com";
const BRAND = "Iridescent Medical & Wellness Spa";
const DEFAULT_TITLE = `Med Spa in Clinton Township, MI | ${BRAND}`;

function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export function Seo({ title, description, path = "/", noindex = false }) {
  useEffect(() => {
    const full = title ? `${title} | ${BRAND}` : DEFAULT_TITLE;
    document.title = full;
    const url = SITE + (path || "/");
    upsertMeta("property", "og:title", full);
    upsertMeta("name", "twitter:title", full);
    upsertMeta("property", "og:url", url);
    upsertCanonical(url);
    upsertMeta("name", "robots", noindex ? "noindex,nofollow" : "index,follow");
    if (description) {
      upsertMeta("name", "description", description);
      upsertMeta("property", "og:description", description);
      upsertMeta("name", "twitter:description", description);
    }
  }, [title, description, path, noindex]);

  return null;
}
